<audio #audioplayer
  [src]="list"
  [autoplay]="autoplay()"
  [controls]="controls()"
  [volume]="volume()"
  [loop]="loop()"
  [preload]="preload()"
  [muted]="muted()"
  >
</audio>
@if (playButton()) {
  <button type="button" (click)="play()">Play</button>
}
@if (pauseButton()) {
  <button type="button" (click)="pause()">Pause</button>
}
@if (selectableButton()) {
  <button type="button" (click)="previousTrack()">Previous</button>
}
@if (selectableButton()) {
  <button type="button" (click)="nextTrack()">Next</button>
}
@if (muteButton()) {
  <button type="button" (click)="muteVideo()">Mute</button>
}